import { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
        setMenuOpen(false);
    };

    const navLinks = [
        { label: 'Overview', id: 'overview' },
        { label: 'Collage', id: 'collage' },
        { label: 'Timeline', id: 'timeline' },
        { label: 'Legacy', id: 'quote' },
    ];

    return (
        <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
            <div className="navbar__logo" onClick={() => scrollTo('hero')}>
                <span className="navbar__logo-crescent">☽</span>
                <span className="navbar__logo-text">Salah Eldin</span>
            </div>

            <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
                {navLinks.map((link) => (
                    <li key={link.id}>
                        <button className="navbar__link" onClick={() => scrollTo(link.id)}>
                            {link.label}
                        </button>
                    </li>
                ))}
            </ul>

            <button
                className={`navbar__burger ${menuOpen ? 'navbar__burger--open' : ''}`}
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
        </nav>
    );
};

export default Navbar;
